import { IDatePreset } from "../../components/CustomDateRangePicker";
import { Moment } from "moment";
import moment from "moment";

export function renderConsumptionSchedulingDatePresets(startDate: Nullable<Moment>) {
    const datePresets: IDatePreset[] = [
        {
            start: moment(startDate || undefined),
            end: moment(startDate || undefined).add(3, "month"),
        },
        {
            start: moment(startDate || undefined),
            end: moment(startDate || undefined).add(1, "year"),
        },
        {
            start: moment(startDate || undefined),
            end: moment(startDate || undefined).add(2, "year"),
        },
        {
            start: moment(startDate || undefined),
            end: moment(startDate || undefined).add(5, "year"),
        },
    ];

    return datePresets;
}
